import React, {useEffect} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {Container, Row, Col} from 'reactstrap';
import TextInput from '../../../Shared/TextInput/TextInput';
import {
  changeHandler,
  validateHandler,
  emailIsExist,
  setCustomerEmail,
  setEmailIfCustomerExist,
  setReceivingBill,
  clearValid,
  reportAnalytics,
} from './CustomerEmailSlice';
import {connect} from 'react-redux';
import CheckBox from '../../../Shared/CheckBox/Checkbox';

const customerEmail = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.form.email == '') {
        props.setCustomerEmail(props.customerEmail.email);
      }
    }
  }, []);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
      }
      if (props.onSubmit) {
        props.validateHandler(props.form);
      }
    },
    [props.onSubmit],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
      }
      if ((props.form.valid !== '' && props.saleType === 'tv') || props.saleType === 'app') {
        getCaptchaandCheckEmail();
      }
      if (props.form.valid == true && props.saleType !== 'tv' && props.saleType !== 'app') {
        props.clearValid();
        props.onValid(true);
      } else {
        props.onValid(false);
      }
    },
    [props.form.valid],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if ((props.isEmailFree && props.saleType === 'tv') || props.saleType === 'app') {
          props.clearValid();
          props.onValid(true);
        } else {
          props.onValid(false);
        }
      }
    },
    [props.isEmailFree],
  );

  async function getCaptchaandCheckEmail() {
    props.emailIsExist({eMailAddress: props.form.email});
  }

  return (
    <Container className='customerEmail'>
      <Row>
        <Col>
          <div className='input-container'>
            <TextInput
              className='email-inp'
              name='email'
              type='email'
              id='email'
              autoComplete='off'
              placeholder='כתובת מייל'
              value={props.form.email}
              error={props.form.errors.email}
              onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
            />
            <Row className='email-note'>
              <Col xs='10' md='10'>
                {props.isEmailFree === false ? <div className='existedEmail'>קיים כבר מנוי TV על המייל הזה, יש מייל אחר?</div> : null}
                {props.saleType === 'tv' && (
                  <div>
                    <span>{`אל כתובת המייל הזאת נשלח את סיסמת הכניסה שלכם ל${window.Config.brand_Name_HE} TV ואת החשבונית`}</span>
                  </div>
                )}
              </Col>
            </Row>
            {props.showInvoiceLabel !== false && (
              <Row className='approve-bills'>
                <Col xs='1' md='1'>
                  <div>
                    <CheckBox
                      checked={props.isReceivingBill}
                      id='approveReceivingBillsExistedCustomer'
                      onCheck={(e) => props.setReceivingBill({target: e.target, receiveMsgs: props.isReceivingBill})}
                      onUncheck={(e) => props.setReceivingBill({target: e.target, receiveMsgs: props.isReceivingBill})}></CheckBox>
                  </div>
                </Col>

                <Col xs='10' md='11'>
                  <label htmlFor='approveReceivingBillsExistedCustomer'>
                    אני רוצה לקבל את החשבונית למייל שהזנתי (במקרה בו תסיר את הסימון, תשלח החשבונית לכתובת המגורים שמילאת)
                  </label>
                </Col>
              </Row>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.CustomerEmail.form,
    isEmailFree: state.CustomerEmail.isEmailFree,
    isReceivingBill: state.CustomerEmail.isReceivingBill,
    productsInfo: state.saleBlock.productsInfo,
  };
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  emailIsExist,
  setCustomerEmail,
  setEmailIfCustomerExist,
  setReceivingBill,
  clearValid,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(customerEmail);
